<template>
  <div>
    <ctable @showContract="showContract"></ctable>
    <el-dialog :visible.sync="DialogVisible" width="90%" top="30px">
      <createCT :btn_modify="true" ref="createCTRef"></createCT>
    </el-dialog>
    <el-dialog
      title="合同正文"
      :visible.sync="contractBDVisible"
      width="55%"
      top="52px"
      style="padding:10px;"
    >
      <contractBD ref="contractBDRef"></contractBD>
    </el-dialog>
  </div>
</template>
<script>
import createCT from "./createCT.vue";
import contractBD from "./contractBD.vue";
import ctable from "./ctable.vue";
export default {
  name: "sendCT",
  components: { createCT, contractBD, ctable },
  inject: ["QueryContract"],
  data() {
    return {
      //修改、查看合同
      DialogVisible: false,
      //查看合同正文
      contractBDVisible: false
    };
  },
  mounted() {},
  methods: {
    showContract(e) {
      if (e.key == "look") {
        this.contractBDVisible = true;
        this.$nextTick(() => {
          this.$refs.contractBDRef.assignment(e.row);
        });
      } else if (e.key == "modify") {
        this.DialogVisible = true;
        this.$nextTick(()=>{
          this.$refs.createCTRef.setUpdateInfo(e.row);
        })
      }
    }
  }
};
</script>
<style scoped></style>
